// removed by extract-text-webpack-plugin
module.exports = {"prices-container":"style__prices-container___1c95Q","price-group":"style__price-group___2OxD9","price-input":"style__price-input___2usc7"};


//////////////////
// WEBPACK FOOTER
// ./components/PriceInputs/style.scss
// module id = 1340
// module chunks = 0